export class DefinitionTooltip extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.initEventListeners();
    }

    initEventListeners() {
        // look mouse moving out of this or parent
        const parent = this.parentElement;
        // send the event to mouseout
        parent.addEventListener("mouseout", this.mouseOut.bind(this));
        this.addEventListener("mouseout", this.mouseOut.bind(this));
    }

    mouseOut(event) {
        // wait, then check if mouse is still over either element or one of it's descendants, after a short delay
        // if so, do nothing; if not, hide the tooltip
        setTimeout(() => {
            if (!this.parentElement) return;
            const elementUnderMouse = document.elementFromPoint(event.clientX, event.clientY);
            if (this.contains(elementUnderMouse) || this.parentElement.contains(elementUnderMouse)) {
                return;
            }
            if (this.matches(":hover") || this.parentElement.matches(":hover")) {
                return;
            }


            this.hideTooltip();
        }, 500);

    }

    hideTooltip() {
        const dialog = this.querySelector("dialog");
        dialog.style.opacity = "0";
        // after transition, remove the tooltip from the DOM
        dialog.addEventListener(
            "transitionend",
            () => {
                if (this.parentElement) {
                    dialog.close();
                    this.parentElement.removeChild(this);
                }
            },
            { once: true }
        );
    }

    parentMouseMove(tooltip, target, event) {
        // determine if mouse is still over the term or the tooltip
        const targetRect = target.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const mouseX = event.clientX;
        const mouseY = event.clientY;
        const isOverTarget =
            mouseX >= targetRect.left &&
            mouseX <= targetRect.right &&
            mouseY >= targetRect.top &&
            mouseY <= targetRect.bottom;
        const isOverTooltip =
            mouseX >= tooltipRect.left &&
            mouseX <= tooltipRect.right &&
            mouseY >= tooltipRect.top &&
            mouseY <= tooltipRect.bottom;
        if (!isOverTarget && !isOverTooltip) {
            this.hideTooltip();
        }
    }
}

customElements.define("definition-tooltip", DefinitionTooltip);
